import { FC } from 'react';
import { Breadcrumbs } from '@mui/material';
import LinkRouter from 'components/Base/LinkRouter';
import { TBreadcrumbItem } from './BreadcrumbNavigation.types';
import EditableLastItem from './EditableLastItem';

type TBreadcrumbNavigationProps = {
  items: TBreadcrumbItem[];
};

const BreadcrumbNavigation: FC<TBreadcrumbNavigationProps> = ({ items }) => {
  return (
    <Breadcrumbs
      sx={{
        fontSize: '0.9375rem',
        '& ol': {
          justifyContent: 'center',
          margin: 'auto',
        },
        '& .MuiBreadcrumbs-separator': {
          mx: 1,
          color: 'text.secondary',
        },
      }}
    >
      {items.map((item, index, arr) => {
        const last = index === arr.length - 1;
        return last ? (
          <EditableLastItem
            initialValue={item.text}
            key={item.text}
            onUpdate={item.onUpdateText}
          />
        ) : (
          <LinkRouter
            underline="hover"
            color="text.secondary"
            key={item.text}
            {...(item.onClick && { onClick: item.onClick })}
            to={{
              pathname: `/${item.link}`,
              ...(item.search && { search: item.search }),
            }}
            sx={{
              fontWeight: 500,
              '&:hover': {
                color: 'primary.main',
              },
            }}
          >
            {item.text}
          </LinkRouter>
        );
      })}
    </Breadcrumbs>
  );
};

export default BreadcrumbNavigation;
